export default "__VITE_ASSET__04b16c9c__"